export default __webpack_public_path__ + "static/media/p1.102f0e0a.png";